module.exports = __webpack_public_path__ + "img/ukf.1a721158.svg";